/**
 * Endereço do arquivo exportado cuja aba o navegador bloqueou, por chave do export (`lista` ou o
 * casoId), à espera do clique em "Baixar arquivo".
 *
 * Fica fora do Redux de propósito: a URL assinada é credencial temporária e não pode ir para o
 * estado nem para uma action (regra 1 do CLAUDE.md, mesma razão de `usePreviaDaMidia`). E não
 * cabe no estado local de um componente: na visão Assinaturas quem exporta é o menu do cabeçalho
 * e quem mostra o aviso é a visão, duas instâncias de `useExportarAssinaturas`. Vive só na memória
 * da página e sai no próximo export, no clique, quando a tela desmonta ou na troca de escritório.
 */
import { getStoredWorkspaceId } from '@/shared/utils/workspace';
import type { ArquivoParaBaixar } from '../types/negociacaoAssinaturasTypes';

const enderecos = new Map<string, ArquivoParaBaixar>();
const ouvintes = new Set<() => void>();

const avisar = () => ouvintes.forEach((ouvinte) => ouvinte());

export function guardarArquivoParaBaixar(chave: string, endereco: string): void {
  enderecos.set(chave, { endereco, escritorio: getStoredWorkspaceId() });
  avisar();
}

export function descartarArquivoParaBaixar(chave: string): void {
  if (!enderecos.delete(chave)) return;
  avisar();
}

/** Na troca de escritório: nenhum arquivo do escritório anterior fica oferecido na tela. */
export function descartarArquivosParaBaixar(): void {
  if (enderecos.size === 0) return;
  enderecos.clear();
  avisar();
}

export const lerArquivoParaBaixar = (chave: string): string | null => {
  const arquivo = enderecos.get(chave);
  return arquivo?.escritorio === getStoredWorkspaceId() ? arquivo.endereco : null;
};

export function assinarArquivosParaBaixar(ouvinte: () => void): () => void {
  ouvintes.add(ouvinte);
  return () => {
    ouvintes.delete(ouvinte);
  };
}
